import gql from 'graphql-tag';
import ProductAttributeListItem from '../fragments/ProductAttributeListItem';

export default gql`
query AdminProductAttributeList {
    adminProductAttributes {
        ...ProductAttributeListItem
    }
}
${ProductAttributeListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductAttributeList.ts